/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {HasInvestingHoldingsRequest} from '@cash-web/protos/squareup/cash/portfolios/server/service.pb'
import {HasInvestingHoldingsResponse} from '@cash-web/protos/squareup/cash/portfolios/server/service.pb'


export const hasInvestingHoldings = (request: HasInvestingHoldingsRequest, options?: CashRequestOptions) => post<HasInvestingHoldingsRequest, HasInvestingHoldingsResponse>("/2.0/cash/has-investing-holdings", request, {...options, rejectOnError: true })